<template>
  <section class="section columns is-centered">
    <div class="box column container is-four-fifths post-container">
      <div class="box">
        <h1 class="box title is-4">{{post.title}}</h1>
        <div v-html="post.content" v-if="post.content" class="has-text-left"></div>
        <div v-if="post.document_id">
          <h2 class="subtitle is-5">{{document.name}}</h2>
          <div v-html="document.content" class="has-text-left"></div>
          <div class="box has-text-centered">
            <h2 class="subtitle is-6">Attachments</h2>
            <div
              v-for="(attachment) in document.attachments"
              :key="attachment.id"
              class="is-clearfix"
            >
              <a
                :href="attachment.url"
                class="is-small is-pulled-left"
                target="_blank"
              >{{ attachment.filename }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-left">
        <div class="modal" :class="{'is-active':showReply}">
          <div class="modal-background" @click.prevent="hideReplyModal"></div>
          <div class="modal-content section box">
            <div class="wrapper">
              <button
                @click.stop="openReplyEmoji"
                :class="{ 'is-danger': wrongInput}"
                class="button emojiButton"
                id="test"
              >😃</button>

              <textarea
                class="textarea commentArea"
                v-model="input"
                :class="{ 'is-danger': wrongInput}"
              ></textarea>
              <button
                class="button is-pulled-left"
                @click.prevent="submitReplyComment"
              >Submit Comment</button>

              <emoji-picker class="emojiPicker column is-half" :search="search">
                <div
                  class
                  slot="emoji-invoker"
                  slot-scope="{ events: { click: clickEvent } }"
                  @click.stop="clickEvent"
                  ref="ReplyEmojiOpen"
                ></div>
                <div slot="emoji-picker" slot-scope="{ emojis }">
                  <div class>
                    <div class>
                      <input
                        class="input"
                        placeholder="Search..."
                        type="text"
                        v-model="search"
                        v-focus
                      />
                    </div>
                    <div class="emojiBox">
                      <div v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5 class>{{ category }}</h5>
                        <div class>
                          <button
                            class="button"
                            v-for="(emoji, emojiName) in emojiGroup"
                            :key="emojiName"
                            @click="append(emoji)"
                            :title="emojiName"
                          >{{ emoji }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </emoji-picker>
            </div>
          </div>
          <button @click.prevent="hideReplyModal" class="modal-close is-large" aria-label="close"></button>
        </div>
        <div class="modal" :class="{'is-active':showDelete}">
          <div class="modal-background" @click.prevent="hideDeleteModal"></div>
          <div class="modal-content section box">
            <div
              class="has-text is-size-3 delete-text has-text-centered"
            >Are you sure you would like to delete?</div>
            <div class="field is-grouped delete-buttons">
              <div class="control">
                <button class="button is-link" @click.prevent="hideDeleteModal">Cancel</button>
              </div>
              <div class="control">
                <button
                  class="button is-text"
                  @click.prevent="deleteComment(commentToDelete)"
                >Confirm</button>
              </div>
            </div>
          </div>
          <button @click.prevent="hideDeleteModal" class="modal-close is-large" aria-label="close"></button>
        </div>
        <div v-for="(comment, l) in sortedComments" :key="l" class="box comment">
          <article class="media">
            <div class="media-left">
              <figure class="image is-64x64">
                <img :src="comment.creator.profile_image" alt="Image" />
              </figure>
            </div>
            <div class="media-content level">
              <div class="content level-left comment-text-container">
                <p>
                  <strong>{{comment.creator.full_name}}</strong>
                  <small>{{dateFormat(comment.created_at.date)}}</small>
                  <br />
                  {{commentContent(comment.body)}}
                </p>
              </div>
              <div class="level-right">
                <!-- <button
                  v-if="$store.state.auth.user.is_admin || $store.state.auth.user.id == comment.creator.id"
                  class="button delete-button"
                  @click.prevent="showDeleteModal(comment.id)"
                >Delete</button>-->
                <button
                  class="button reply-button"
                  @click.prevent="showReplyModal(comment.id)"
                >Reply</button>
              </div>
            </div>
          </article>
          <div v-if="comment.comments.length > 0">
            <div
              v-for="(threadcomment, m) in comment.comments"
              :key="m"
              class="box thread-comment comment"
            >
              <article class="media">
                <div class="media-left">
                  <figure class="image is-64x64">
                    <img :src="threadcomment.creator.profile_image" alt="Image" />
                  </figure>
                </div>
                <div class="media-content level">
                  <div class="content level-left comment-text-container">
                    <p>
                      <strong>{{threadcomment.creator.full_name}}</strong>
                      <small>{{dateFormat(threadcomment.created_at)}}</small>
                      <br />
                      {{commentContent(threadcomment.body)}}
                    </p>
                  </div>
                  <div class="level-right">
                    <!-- <button
                      v-if="$store.state.auth.user.is_admin || $store.state.auth.user.id == threadcomment.creator.id"
                      class="button delete-button"
                      @click.prevent="showDeleteModal(threadcomment.id)"
                    >Delete</button>-->
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
        <div class="wrapper">
          <button
            @click.stop="openEmoji"
            :class="{ 'is-danger': wrongInput}"
            class="button emojiButton"
            id="test"
          >😃</button>

          <textarea
            class="textarea commentArea"
            v-model="input"
            :class="{ 'is-danger': wrongInput}"
          ></textarea>
          <button class="button is-pulled-left" @click.prevent="submitComment">Submit Comment</button>

          <emoji-picker class="emojiPicker column is-half" :search="search">
            <div
              class
              slot="emoji-invoker"
              slot-scope="{ events: { click: clickEvent } }"
              @click.stop="clickEvent"
              ref="EmojiOpen"
            ></div>
            <div slot="emoji-picker" slot-scope="{ emojis }">
              <div class>
                <div class>
                  <input class="input" placeholder="Search..." type="text" v-model="search" v-focus />
                </div>
                <div class="emojiBox">
                  <div v-for="(emojiGroup, category) in emojis" :key="category">
                    <h5 class>{{ category }}</h5>
                    <div class>
                      <button
                        class="button"
                        v-for="(emoji, emojiName) in emojiGroup"
                        :key="emojiName"
                        @click="append(emoji)"
                        :title="emojiName"
                      >{{ emoji }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </emoji-picker>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { ForumClient } from "../../clients/ForumClient.js";
import { DocumentClient } from "../../clients/DocumentClient.js";
import { log } from "util";

export default {
  name: "Forum",
  props: ["forumId", "topicId", "postId"],
  methods: {
    deleteComment(commentId) {
      ForumClient.deleteComment(commentId)
        .then(response => {
          this.commentToDelete = "";
          this.getPost();
          this.hideDeleteModal();
        })
        .catch(error => {
          console.log(error);
        });
    },
    showReplyModal(commentId) {
      this.parent_id = commentId;
      this.showReply = true;
    },
    hideReplyModal() {
      this.showReply = false;
      this.parent_id = null;
    },
    showDeleteModal(commentId) {
      this.commentToDelete = commentId;
      this.showDelete = true;
    },
    hideDeleteModal() {
      this.showDelete = false;
    },
    commentContent(content) {
      return decodeURIComponent(content);
    },
    getDocument(documentId) {
      DocumentClient.getDocument(documentId)
        .then(response => {
          this.document = response.data.document;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPost() {
      ForumClient.getPost(this.forumId, this.topicId, this.postId)
        .then(response => {
          this.post = response.data.post;
          if (this.post.document_id) {
            this.getDocument(this.post.document_id);
          }
        })
        .then(() => {
          this.$store.dispatch("loader/hide");
        })
        .catch(error => {
          console.log(error);
        });
    },
    dateFormat(date) {
      return " @" + this.$moment(date).format("dddd, D MMMM YYYY, HH:mm");
    },

    append(emoji) {
      this.input += emoji;
    },
    openEmoji() {
      this.$refs.EmojiOpen.click();
    },
    openReplyEmoji() {
      this.$refs.ReplyEmojiOpen.click();
    },
    submitReplyComment() {
      if (this.input) {
        ForumClient.createReplyComment(
          this.forumId,
          this.topicId,
          this.postId,
          this.parent_id,
          encodeURIComponent(this.input)
        )
          .then(response => {
            this.input = "";
            this.getPost();
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.wrongInput = true;
        setTimeout(() => {
          this.wrongInput = false;
        }, 600);
      }
      this.showReply = false;
    },
    submitComment() {
      if (this.input) {
        ForumClient.createComment(
          this.forumId,
          this.topicId,
          this.postId,
          encodeURIComponent(this.input)
        )
          .then(response => {
            this.input = "";
            this.getPost();
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.wrongInput = true;
        setTimeout(() => {
          this.wrongInput = false;
        }, 600);
      }
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  },
  data() {
    return {
      wrongInput: false,
      input: null,
      search: "",
      post: { comments: [] },
      document: Object,
      commentToDelete: "",
      showDelete: false,
      showReply: false
    };
  },
  computed: {
    sortedComments() {
      return this.post.comments.filter(comment => !Array.isArray(comment));
    }
  },

  mounted() {
    this.$store.dispatch("loader/show", "Loading post...");
    this.getPost();
    if (this.post.document_id) {
      this.getDocument(this.post.documentId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
@import "../../assets/scss/post.scss";
</style>


